import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../../shared/components/layout/Sidebar';
import Hub from './overview/Hub';
import Source from './overview/Source';
import ProductUsage from './overview/ProductUsage';
import Onchain from './overview/Onchain';
import Retention from './overview/Retention';
import WalletList from './overview/WalletList';
import SubscriptionRequired from '../../../shared/components/subscription/SubscriptionRequired';
import { useSubscription } from '../../../shared/context/subscriptionContext';
import { OverviewFilterProvider } from '../../../shared/context/OverviewFilterContext';

const OverviewWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { team } = useParams();
  const { isActive } = useSubscription();
  
  // Determine active subpage from route
  // Path structure: /:team/overview/:subpage
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const subPage = pathSegments[1] === 'overview' 
    ? (pathSegments[2] || 'hub') 
    : 'hub';
  
  // Redirect to /hub if on base overview path
  useEffect(() => {
    if (pathSegments[1] === 'overview' && !pathSegments[2]) {
      navigate(`/${team}/overview/hub`, { replace: true });
    }
  }, [location.pathname, navigate, team]);
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [screenSize, setScreenSize] = useState({ isMobile: false, isTablet: false, isDesktop: true });

  // Responsive sidebar behavior
  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      const isMobile = width < 640;
      const isTablet = width >= 640 && width < 1024;
      const isDesktop = width >= 1024;
      setScreenSize({ isMobile, isTablet, isDesktop });
      setIsSidebarOpen(isDesktop);
    };
    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  const renderContent = () => {
    switch (subPage) {
      case 'hub':
        return <Hub />;
      case 'source':
        return <Source />;
      case 'product-usage':
        return <ProductUsage />;
      case 'onchain':
        return <Onchain />;
      case 'retention':
        return <Retention />;
      case 'wallet-list':
        return <WalletList />;
      default:
        return <Hub />;
    }
  };

  return (
    <OverviewFilterProvider>
      <div className="flex h-screen overflow-hidden relative" style={{ fontFamily: 'Raleway, sans-serif' }}>
        {/* Collapsible Sidebar */}
        <div className="h-screen sticky top-0 flex-shrink-0">
          <Sidebar 
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            currentPage="overview"
            isCompact={true}
            screenSize={screenSize}
          />
        </div>

        <div className="flex flex-col flex-1 h-screen relative z-10 text-[14px] md:text-[16px] typography-normal min-w-0">
          {/* Main content (gated) */}
          <div className="flex-1 overflow-y-auto min-w-0">
            <SubscriptionRequired featureName="Overview" requiredPage="overview">
              {renderContent()}
            </SubscriptionRequired>
          </div>
        </div>
      </div>
    </OverviewFilterProvider>
  );
};

export default OverviewWrapper;

